export default {
  SearchResults: 'results',
  Layers: 'layers',
  Measure: 'measure',
  Help: 'info',
};
